import { Card, Empty } from "antd"
import React, { useRef } from "react"

import { ApprovalDocumentPreview } from "../../../../components/ApprovalDocumentPreview.tsx"
import { type Proposal } from "../../types/types.ts"
import { ProposalsViewScrollTabs } from "./ProposalsViewScrollTabs.tsx"
import { ProposalsViewVersions } from "./ProposalsViewVersions.tsx"

interface ProposalsView {
  proposal: Proposal
}

export function ProposalViewBody({ proposal }: ProposalsView) {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const documentRef = useRef<HTMLDivElement | null>(null)
  const versionsRef = useRef<HTMLDivElement | null>(null)
  // const commentsRef = useRef<HTMLDivElement | null>(null)

  const fileUrl = proposal?.submitted_attachment?.file_url
  const attachments = proposal?.attachments
  const versionDisplayDate =
    proposal?.reviewed_at || proposal?.submitted_for_review_at

  return (
    <>
      <ProposalsViewScrollTabs
        refsMap={{
          container: containerRef,
          document: documentRef,
          versions: versionsRef
          // comments: commentsRef
        }}
      />

      <div
        ref={containerRef}
        className="flex-1 space-y-2 overflow-auto tailwind-scroll"
      >
        {fileUrl ? (
          <ApprovalDocumentPreview ref={documentRef} pdfUrl={fileUrl} />
        ) : (
          <Card>
            <Empty description={"Pdf not found"} />
          </Card>
        )}
        <div ref={versionsRef}>
          {attachments?.length ? (
            <ProposalsViewVersions
              attachments={attachments}
              displayDate={versionDisplayDate}
            />
          ) : (
            <Card>
              <Empty description={"Version history is empty"} />
            </Card>
          )}
        </div>
        {/*<div ref={commentsRef}>*/}
        {/*  <ProposalsViewComments />*/}
        {/*</div>*/}
      </div>
    </>
  )
}
